import React, { lazy, Component } from 'react';
import { CheckCircle2, Clock, Calendar, AlertCircle } from 'lucide-react';
export function OfferSection() {
  const handleVirtualWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, Seleccionar Asesoría Virtual');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  const handlePresencialWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, Seleccionar Asesoría Presencial');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section id="offer" className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-95">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-96">
        <div className="text-center mb-8 md:mb-16" data-id="element-97">
          <div className="inline-block bg-[#E8621A] text-white px-4 py-1.5 md:px-6 md:py-2 rounded-full text-[11px] md:text-[12px] font-semibold mb-3 md:mb-4 uppercase" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-98">
            OFERTA LIMITADA
          </div>
          <h2 className="text-[26px] md:text-[40px] font-bold text-[#1A1A1A] mb-2 md:mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-99">
            Empieza por aquí.
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal max-w-2xl mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-100">
            Antes de tomar cualquier decisión sobre tu obra, habla primero con
            nosotros.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-101">
          {/* Left: Checklist */}
          <div className="space-y-4 md:space-y-6" data-id="element-102">
            <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-4 md:mb-6 text-center md:text-left" style={{
            lineHeight: '1.3'
          }} data-id="element-103">
              En una sola sesión puedes llegar a saber:
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-104">
              {['Qué tan viable es lo que tienes en mente', 'Qué errores evitar antes de gastar un peso', 'Cuánto podría costar de forma realista', 'Por dónde empezar si decides seguir adelante'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-105">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#E8621A] flex-shrink-0 mt-0.5" data-id="element-106" />
                  <span className="text-[15px] md:text-[17px] text-[#1A1A1A]/80 font-normal" style={{
                lineHeight: '1.6'
              }} data-id="element-107">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right: Reminder Card */}
          <div className="bg-[#E8621A]/5 border-2 border-[#E8621A] rounded-2xl md:rounded-3xl p-6 md:p-8" data-id="element-108">
            <AlertCircle className="w-10 h-10 md:w-12 md:h-12 text-[#E8621A] mb-3 md:mb-4 mx-auto md:mx-0" data-id="element-109" />
            <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-3 md:mb-4 text-center md:text-left" style={{
            lineHeight: '1.3'
          }} data-id="element-110">
              ⏰ Oferta por Tiempo Limitado
            </h3>
            <div className="space-y-3 md:space-y-4 mb-4 md:mb-6" data-id="element-111">
              <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/70 font-normal text-center md:text-left" style={{
              lineHeight: '1.6'
            }} data-id="element-112">
                Aprovecha nuestro{' '}
                <span className="font-bold text-[#E8621A]" data-id="element-113">
                  35% de descuento
                </span>{' '}
                en todos los paquetes. Esta promoción especial termina el 31 de
                Mayo de 2026.
              </p>
              <div className="bg-white rounded-xl md:rounded-2xl p-3 md:p-4 space-y-2" data-id="element-114">
                <div className="flex items-center gap-2 text-[12px] md:text-[13px]" style={{
                lineHeight: '1.5'
              }} data-id="element-115">
                  <Calendar className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#E8621A]" data-id="element-116" />
                  <span className="font-medium text-[#1A1A1A]" data-id="element-117">
                    Válido hasta: 7 Junio 2026
                  </span>
                </div>
                <div className="flex items-center gap-2 text-[12px] md:text-[13px]" style={{
                lineHeight: '1.5'
              }} data-id="element-118">
                  <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#E8621A]" data-id="element-119" />
                  <span className="font-medium text-[#1A1A1A]" data-id="element-120">
                    Cupos disponible: 5 cupos
                  </span>
                </div>
              </div>
            </div>
            <p className="text-[#1A1A1A]/60 font-normal text-[12px] md:text-[13px] text-center md:text-left" style={{
            lineHeight: '1.5'
          }} data-id="element-121">
              * Aplica para proyectos contratados antes de la fecha límite o
              hasta agotar los cupos disponibles. No acumulable con otras
              promociones.
            </p>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-122">
          {/* Virtual Package */}
          <div className="bg-white border-2 border-[#1A1A1A]/10 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:border-[#E8621A]/30 transition-all hover:shadow-xl" data-id="element-123">
            <div className="mb-4 md:mb-6 text-center md:text-left" data-id="element-124">
              <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-2" style={{
              lineHeight: '1.3'
            }} data-id="element-125">
                Virtual
              </h3>
              <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-126">
                Por videollamada · Mandas fotos y planos si los tienes · Te
                orientamos sin necesidad de visita
              </p>
            </div>
            <div className="mb-4 md:mb-6 text-center md:text-left" data-id="element-127">
              <div className="flex items-baseline gap-2 md:gap-3 mb-2 justify-center md:justify-start" data-id="element-128">
                <span className="text-3xl md:text-5xl font-black text-[#1A1A1A]" data-id="element-129">
                  $100.000
                </span>
                <span className="text-lg md:text-2xl text-[#1A1A1A]/40 line-through font-light" data-id="element-130">
                  $143.000
                </span>
              </div>
              <div className="inline-block bg-[#E8621A] text-white px-3 py-1 md:px-4 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-131">
                AHORRA 30%
              </div>
            </div>
            <button onClick={handleVirtualWhatsApp} className="w-full bg-[#1A1A1A] text-white py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#E8621A] transition-colors min-h-[52px]" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-132">
              Seleccionar Asesoría Virtual
            </button>
          </div>

          {/* Presencial Package */}
          <div className="bg-gradient-to-br from-[#E8621A] to-[#d55515] rounded-2xl md:rounded-3xl p-6 md:p-8 text-white relative overflow-hidden shadow-2xl" data-id="element-133">
            <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-white text-[#E8621A] px-3 py-1 rounded-full text-[11px] font-semibold uppercase" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-134">
              MÁS POPULAR
            </div>
            <div className="mb-4 md:mb-6 text-center md:text-left" data-id="element-135">
              <h3 className="text-[20px] md:text-[28px] font-semibold mb-2" style={{
              lineHeight: '1.3'
            }} data-id="element-136">
                Presencial
              </h3>
              <p className="text-[15px] md:text-[17px] text-white/90 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-137">
                Vamos al inmueble · Revisamos todo en persona · resolvemos tus
                dudas.
              </p>
            </div>
            <div className="mb-4 md:mb-6 text-center md:text-left" data-id="element-138">
              <div className="flex items-baseline gap-2 md:gap-3 mb-2 justify-center md:justify-start" data-id="element-139">
                <span className="text-3xl md:text-5xl font-black" data-id="element-140">
                  $126.000
                </span>
                <span className="text-lg md:text-2xl text-white/60 line-through font-light" data-id="element-141">
                  $180.000
                </span>
              </div>
              <div className="inline-block bg-white text-[#E8621A] px-3 py-1 md:px-4 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-142">
                AHORRA 30%
              </div>
            </div>
            <button onClick={handlePresencialWhatsApp} className="w-full bg-white text-[#E8621A] py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-white/90 transition-colors shadow-lg min-h-[52px]" style={{
            lineHeight: '1',
            letterSpacing: '0.08em'
          }} data-id="element-143">
              Seleccionar Asesoría Presencial
            </button>
          </div>
        </div>

        <p className="text-center text-[#1A1A1A]/60 font-normal text-[12px] md:text-[13px] mt-6 md:mt-8" style={{
        lineHeight: '1.5'
      }} data-id="element-144">
          * Precios en COP. Pueden variar según complejidad del proyecto.
          Consulta sin compromiso.
        </p>

        {/* Gift Image */}
        <div className="w-full mt-8 md:mt-12" data-id="element-145">
          <img src="https://cdn.magicpatterns.com/uploads/h2w3NYAuYQXKuciA83Es1Q/Gerfaj_-_regalo_-_blanco.png" alt="Si haces la obra con nosotros, te devolvemos el valor de la asesoría inicial" className="w-full h-auto object-cover rounded-2xl md:rounded-3xl" width="1200" height="400" loading="lazy" decoding="async" data-id="element-146" />
        </div>
      </div>
    </section>;
}